<template>
    <section class="mbs-wrap mbs004">
        <div class="mbs-inner clear">
            <LoginLeft/>
            <div class="mbs-right">
                <div class="tit">{{ $i18nUtil.trans("message.ModifyPassword.001", "비밀번호 재설정") }}</div>
                <fieldset>
                    <div class="input-box">
                        <input type="password" id="newPassword" name="newPassword" v-model="newPassword" ref="pw" @keyup="passWordValidation" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.password', '비밀번호')" maxlength="10"/>
                        <div class="error-list">
                            <div class="error" v-if="errors.has('newPassword') ">{{ $i18nUtil.trans("message.password.valid.error.001", "* 비밀번호를 입력하세요.") }}</div>
                            <!-- <div class="error" v-if="validStep1 === false">* 비밀번호를 입력하세요.</div> -->
                            <div class="error" v-if="validStep2 === false">{{ $i18nUtil.trans("message.password.valid.error.002", "* 영문/숫자/특수문자 조합하여 8~10자") }}</div>
                            <div class="error" v-if="validStep3 === false">{{ $i18nUtil.trans("message.password.valid.error.003", "* 기존 비밀번호와 동일한 설정 제외") }}</div>
                            <div class="error" v-if="validStep4 === false">{{ $i18nUtil.trans("message.password.valid.error.004", "* 전화번호와 동일한 설정 제외") }}</div>
                            <div class="normal" v-if="isValidPassword === true">{{ $i18nUtil.trans("message.password.valid.error.005", "* 사용할 수 있는 비밀번호 입니다.") }}</div>
                        </div>
                    </div>
                    <div class="input-box">
                        <input type="password" id="confirmPassword" name="confirmPassword" v-model="confirmPassword" @keyup="confirmNewPassword" v-validate="'required'" :placeholder="$i18nUtil.trans('message.placeholder.password.confirm', '비밀번호 확인')" maxlength="10"/>
                        <div class="error-list">
                            <div class="error" v-if="errors.has('confirmPassword')">{{ $i18nUtil.trans("message.password.valid.error.001", "* 비밀번호를 입력하세요.") }}</div>
                            <div class="normal" v-if="isPasswordSame === true">{{ $i18nUtil.trans("message.ModifyPassword.002", "* 신규 비밀번호와 일치") }}</div>
                            <div class="error" v-if="isPasswordSame === false">{{ $i18nUtil.trans("message.ModifyPassword.003", "* 신규 비밀번호와 불일치") }}</div>
                        </div>
                    </div>
                    <button type="button" class="btn_login" @click="modifyPassword">{{ $i18nUtil.trans("button.confirm", "확인") }}</button>
                </fieldset>
            </div>
        </div>
    </section>
</template>
<script>
import { mapActions } from "vuex";
import LoginLeft from "../base/LoginLeft";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import MainFooter from "@/components/cowork/general/main/MainFooter";
export default {
    components: {
        Dialog,
        LoginLeft,
        MainFooter,
    },
    props : {
        userId : String,
        cellPhoneNo : String
    },
    data() {
        return { 
            /* 기존 비밀번호 */
            oriPassword : "",
            isOriPwMatch : null,
            /* 신규 비밀번호_1 */
            newPassword : "",
            /* 신규 비밀번호_2 */
            confirmPassword : "",
            /* 신규 비밀번호 대조 */
            isPasswordSame : null,
            /* 최종 비밀번호 사용가능 여부 */
            isValidPassword : null,

            validStep1 : null,
            validStep2 : null,
            validStep3 : null,
            validStep4 : null,
        };
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("chkPw", ["chkValidPw"]),
        ...mapActions("modals", ["showDialog"]),
        /* 신규 비밀번호 일치 확인 */
        confirmNewPassword() {
            let newPw = this.newPassword;
            let chkPw = this.confirmPassword;

            if (newPw != chkPw) {
                this.isPasswordSame = false;
            } else {
                this.isPasswordSame = true;
            }
        },
        /* 신규 비밀번호 유효성 검사 */
        async passWordValidation() {
            let obj = this;
            obj.validStep1 = null;
            obj.validStep2 = null;
            obj.validStep3 = null;
            obj.validStep4 = null;

            let pw = obj.newPassword;
            let pwLen = null;
            if(pw != null) {
                pwLen = pw.length;
            }
             
            obj.isValidPassword = false;

            if (pw == "" || pw == 0 || pw == null || pw == undefined) {
                /* 
                chrome 에서는 alert 과 focus 를 동시에 사용시 무한루프가 발생되어 
                해결하기 위해 setTimeout 사용 
                */
                setTimeout(function () {
                    obj.$refs.pw.focus();
                }, 10);
                obj.validStep1 = false;
                return;
            } else {
                obj.validStep1 = true;
            }
            
            if (pwLen < 8 || pwLen > 10) {
                setTimeout(function () {
                    obj.$refs.pw.focus();
                }, 10);
                obj.validStep2 = false;
                return;
            } else {
                obj.validStep2 = true;
            }
            /* 
                패스워드 유효성 검사 
                : 영문 / 숫자 / 특수문자 체크  
            */
            let isValid = await obj.chkValidPw(pw).then((chkVal) => {
                return chkVal;
            });
            if (!isValid) {
                obj.validStep2 = false
                return;
            } else {
                obj.validStep2 = true;
            }
        },
        modifyPassword() {
            let obj = this;
            obj.$validator.validate().then(valid => {
                if(valid) {
                    if(obj.newPassword === obj.confirmPassword) {
                        let reqData = {
                            url : "/api/auth/org/modifyPwByBeforeLogin",
                            method : "post",
                            params : {
                                userId : obj.userId,
                                newPassword : obj.newPassword,
                                //oriPassword : obj.oriPassword,
                                //cellPhoneNo : obj.cellPhoneNo
                            }
                        };
                        obj
                        .COWORK_REST_SIMPLE_ACTION(reqData)
                        .then(function (res) {
                            let contents = null;
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                button : obj.$i18nUtil.trans("button.dialog.confirm", "확인"),
                                contents : contents
                            };
                            if(res.errorCode != null) {
                                let errorCode = res.errorCode;
                                if(errorCode === "UB030") {/* 현재 비밀번호가 일치하지 않습니다. */
                                    info.contents = obj.$i18nUtil.trans("UB030", "현재 비밀번호가 일치하지 않습니다.");
                                    obj.handleDialog(info);
                                } else if(errorCode === "UB033") {/* 현재 비밀번호와 같아 사용할 수 없습니다. */
                                    obj.validStep3 = false;
                                    info.contents = obj.$i18nUtil.trans("UB033", "현재 비밀번호와 같아 사용할 수 없습니다.");
                                    obj.handleDialog(info);
                                } else if(errorCode === "UB034") {/* 전화번호와 동일하여 사용할 수 없습니다. */
                                    obj.validStep4 = false;
                                    info.contents = obj.$i18nUtil.trans("UB034", "전화번호와 동일하여 사용할 수 없습니다.");
                                    obj.handleDialog(info);
                                } else {
                                    console.log(errorCode);
                                }
                            } else {/* 비밀번호가 변경되었습니다.\n재 로그인 후 사용해주세요. */
                                info.contents = obj.$i18nUtil.trans("AG031", "비밀번호가 변경되었습니다.\n재 로그인 후 사용해주세요.");
                                obj.handleDialog(info);
                                obj.$emit('successModify', {});
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                        }); 
                    } else {
                        obj.isPasswordSame === false;
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            contents: obj.$i18nUtil.trans("message.ModifyPassword.004", "새 비밀번호가 다릅니다."), // "새 비밀번호가 다릅니다.",
                            button : obj.$i18nUtil.trans("button.dialog.confirm", "확인"),
                        }
                        obj.handleDialog(info);
                    }
                }
            });
        },
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                contents : info.contents
            };
            this.showDialog(dialogInfo);
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/login/integrate/ModifyPassword.vue